import { transformObjectValuesToObject } from '@/shared/utils/transformObjectValuesToObject';
import { ValuesOf } from '@/shared/utils/types';

import { IDriverBrief } from './driver-brief';

const TransferRequestStatuses = {
  pending: 'pending',
  scheduled: 'scheduled',
} as const;

type TLicensingAuthorityType = ValuesOf<typeof TransferRequestStatuses>;

const transferRequestStatusesEnum =
  transformObjectValuesToObject<TLicensingAuthorityType>(TransferRequestStatuses);

interface TransferRequest {
  status: TLicensingAuthorityType;
  leavingAtDate: Date;
}

interface IDriver extends IDriverBrief {
  transferRequest?: TransferRequest;
  acceptance?: number | null;
  tags?: string[];
  cityId: string;
  partnerId?: string;
  blockInfo?: {
    blockedAt: Date | null;
    blockedBy?: string;
    notes?: string;
    reason?: string;
  };
  hasContractWithPartner: boolean;
}

type TUpdatePersonalInfoForm = {
  phoneCode: string;
  phoneNumber: string;
};

type TUpdateCurrentVehicleForm = {
  carId: string;
};

type TUpdateDriverForm = TUpdatePersonalInfoForm | TUpdateCurrentVehicleForm;

type TUpdateOwnDriverInfoForm = Pick<
  IDriverBrief,
  'licensingAuthority' | 'licenseNumber' | 'homeAddress'
>;

export type {
  IDriver,
  TUpdateDriverForm,
  TUpdateCurrentVehicleForm,
  TUpdateOwnDriverInfoForm,
  TransferRequest,
  TUpdatePersonalInfoForm,
};
export { transferRequestStatusesEnum, TransferRequestStatuses };
